import { apiClient } from '@/libs/axios';
import type { ApiResponse } from '@/types/api.type';
import { mutationOptions } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import type { Product } from '../types/product.type';

export type DeleteProductPayload = {
  product_id: string;
};
export type DeleteProductResponse = ApiResponse<Product>;

export const deleteProduct = async (
  payload: DeleteProductPayload
): Promise<DeleteProductResponse> => {
  const { product_id } = payload;
  const url = `product/${product_id}`;

  return await apiClient.delete(url);
};

export function deleteProductMutationOptions() {
  return mutationOptions<
    DeleteProductResponse,
    AxiosError,
    DeleteProductPayload
  >({
    mutationFn: deleteProduct,
  });
}
